export default __webpack_public_path__ + "static/media/edge-smooth.66a0929d.PNG";